const breakpoints = {
  lg: "1440px",
  lgMax: "1440px",
  lgMin: "1025px",
  md: "1024px",
  mdMax: "1024px",
  mdMin: "992px",
  sm: "991px",
  smMax: "991px",
  smMin: "768px",
  xs: "767px",
  xsMax: "767px",
  xsMin: "0"
}


export default breakpoints;